import { render, staticRenderFns } from "./VIPVideo.vue?vue&type=template&id=7b058a27&scoped=true&"
import script from "./VIPVideo.vue?vue&type=script&lang=js&"
export * from "./VIPVideo.vue?vue&type=script&lang=js&"
import style0 from "./VIPVideo.vue?vue&type=style&index=0&id=7b058a27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b058a27",
  null
  
)

export default component.exports